module.exports = __webpack_public_path__ + "static/media/FedraSansArabic4.75fa59a1.otf";